<section class="toast-container">
  <mat-icon class="data-icon" *ngIf="data.icon">{{data.icon}}</mat-icon>
  <span [innerHTML]="data.message" class='text-control'></span>
  <span class="cursor-pointer action-link" *ngIf="data.action" (click)="actionBtnClick()">{{data.action}}</span>
  <mat-icon class="cursor-pointer close-icon" (click)="closeToast()">close</mat-icon>
</section>
